export default __webpack_public_path__ + "static/media/visual2.15789661.png";